import React, { useState, useEffect } from 'react'
import { Row, Col ,Modal,Form} from 'react-bootstrap'
import Card from '../../../components/Card'
import { getApiCall, postApiCall, postApiMediaCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import { toast } from 'react-toastify';
import { ROUTES ,NUMBERS_TYPES,NUBMERS_STATUS_LABEL, BULK_UPDATE_DID, BULK_UPDATE_OTHERS, ASSIGN_DID_VMN, ASSIGN_DID_TOLLFREE, SAMPLE_DATA_DID_UPDATE, SAMPLE_DATA_OTHERS_UPDATE} from '../../../utilities/constant';
import { EditIcon, DeleteIcon ,RefreshIcon} from '../../../components/setting/elements';
import { API_NUMBERS_LIST, API_NUMBER_DELETE, API_COUNTRY_CODES_LIST, API_DID_NUMBERS,API_NUMBER_STATUS,API_BULK_ASSIGN_DID,
    API_INDIVIDUAL_ASSIGN_DID,API_NUMBER_EDIT_BULK, API_VOICE_PLAN_LIST , API_COMPANY_LIST, API_DID_MAPPING} from '../../../service/url';
import Loader  from '../../../components/partials/components/loader';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { Routes, useNavigate } from "react-router-dom";
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';
import { getUser } from "../../../utilities/setting";
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import "../../../assets/custom/css/tabs.css"
import exportData from '../../../utilities/export';
import downloadTemplate from '../../../utilities/downloadCsv'
//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
// images for 
import agentImg from '../../../assets/images/icons/agent.png';
import callgroupImg from '../../../assets/images/icons/callgroup.png';
import ivrImg from '../../../assets/images/icons/ivr.png';
import { TabView, TabPanel } from 'primereact/tabview';
import { FiPlus } from 'react-icons/fi';


const numberTypeLabels = NUMBERS_TYPES.map(val => val['label']);
const categoryLabels = ['Free', 'Paid'];
const currencyLabels =['INR','USD'];


export default function NumberList() {
    const { checkAuth } = useAuth();
    const navigate = useNavigate();
    const [numbersList, setNumbersList] = useState([]);
    const [contentId, setContentId] = useState(undefined);
    const [filters, setFilters] = useState({
        actual_number: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        status: { value: null, matchMode: FilterMatchMode.CONTAINS },
        country_code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        state_code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        number_type: { value: null, matchMode: FilterMatchMode.EQUALS },
        category: { value: null, matchMode: FilterMatchMode.EQUALS },
        currency: { value: null, matchMode: FilterMatchMode.EQUALS },
        cost: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        operator: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    });
    const [numberType,setNumberType] = useState("All");
    const [enableDeleteModal, setEnableDeleteModal] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [deleteNumberId, setDeleteNumberId] = useState(undefined);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(null);
    const [countryCodeMap, setCountryCodeMap] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
    const [moduleOperations, setModuleOperations] = useState({});
    const [selectedNumbers, setSelectedNumber] = useState([]);
    const [isMultiDelete, setIsMultiDelete] = useState(false);
    const [showAssignDidButton, setShowAssignDidButton] = useState(false);
    const [showAllocateModal, setShowAllocateModal] = useState(false);
    const [selectedDID, setSelectedDID] = useState(null);
    const [allocateNumberId, setAllocateNumberId] = useState(null);
    const [didOptions, setDidOptions] = useState([]);
    const [allocateStatus, setAllocateStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [expiryDate, setExpiryDate] = useState(null);
    const [expiryDateError, setExpiryDateError] = useState("");
    const [showBulkAssignModal, setShowBulkAssignModal] = useState(false);
    const [csvFile, setCsvFile] = useState(undefined);
    const [selectedNumberType, setSelectedNumberType] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [bulkUpdateButton,setBulkUpdateButton] =useState(true);
    const [bulkUpdateModal,setBulkUpdateModal] =useState(false)
    const [updateNumberType, setUpdateNumberType] = useState('');
    const [userRole, setUserRole] = useState('');
    const [isCompanyUser, checkIsCompanyUser] = useState(false);
    const [isReseller, checkIsReseller] = useState(false);
    const [isCallcenterAdmin, checkIsCallcenterAdmin] = useState(false);
    const [searchValue, setSearchValue] = useState(null);
    const [originalNumbersList, setOriginalNumbersList] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [selectedPlanDetails, setSelectedPlanDetails] = useState([]);
    const [selectedPlanName, setSelectedPlanName] = useState('');
    const [loggedUserId, setLoggedUserId] = useState("")
    const [loggedUserType, setLoggedUserType] = useState("")
    const [loggedUser, setLoggedUser] = useState("")

    
    const handleExport = async () => {
        setButtonDisable(true); 
        await exportData('Numbers', setToastProps, setShowToast);
        setButtonDisable(false); 
    };
  
    const handleCheckboxToggle = (numberId) => {
      const isSelected = selectedNumbers.includes(numberId);
      setSelectedNumber(isSelected
          ? selectedNumbers.filter(id => id !== numberId)
          : [...selectedNumbers, numberId]);
    };
  
    const handleMultiDelete = () => {
          setIsMultiDelete(true);
          setEnableDeleteModal(true);
    };

    const handleAllocateClick = (id) => {
        checkAuth(setToastProps, setShowToast)
        let index = numbersList.map(i => i.id).indexOf(id)
        setAllocateNumberId(id);
        setSelectedDID(null);
        setShowAllocateModal(true);
        setSelectedNumberType(numbersList[index].number_type);
    };

    // useEffect(() => {

    //     if (toastProps) {
    //         setShowToast(true);
    //     }

    // }, [toastProps]);

    useEffect(() => {
        setLoading(true);
        getApiCall(API_NUMBERS_LIST)
            .then(onNumberListSuccess)
            .catch(onError)
            .finally(() => setLoading(false));

        getApiCall(API_COUNTRY_CODES_LIST)
            .then(resp => {
                let ccList = {};
                resp.map((val, idx) => {
                    const id = val['id'];
                    const code = val['calling_code'];
                    ccList[id] = code;
                })
                setCountryCodeMap(ccList);
            })
            .catch(onError);

            getApiCall(API_DID_NUMBERS)
            .then(resp => {
                const didOptions = resp.map(did => ({
                    label: did.actual_number.toString(),
                    value: did.id.toString()
                }));

                setDidOptions(didOptions);
            })
            .catch(onError);
        
  
        getApiCall(API_NUMBER_STATUS)
            .then(resp => {
               const sList= resp.map(item =>({
                status: item.status,
                status_code: item.status_code,
                }))
                
                setAllocateStatus(sList)
            })
            .catch(onError)

    }, []);

    useEffect(() => {
        getUser().then((user) => {
          if (user) {
            setUserRole(user.role);
            setLoggedUserId(user.id)
            setLoggedUser(user)
            if (user.role === USER_ROLES.SUPERADMIN) {
              setLoggedUserType('Superadmin')  
              checkIsSuperAdmin(true);
            }
            if (user.role === USER_ROLES.RESELLER) {
                setLoggedUserType('Reseller')  
                checkIsReseller(true);
              }
            if (user.role === USER_ROLES.COMPANY_ADMIN) {
                setLoggedUserType('Company')  
                checkIsCompanyUser(true);
            }
            if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
                setLoggedUserType('Call Center')  
                checkIsCallcenterAdmin(true);
            }
            if (user?.acl_settings) {
                setModuleOperations(JSON.parse(user.acl_settings.module_operations));
              }
          }
        });
      }, []);


        useEffect(() => {
          getUser().then((resp) => {

            if (resp) {
              setContentId(resp.id);
            }
          });
        }, []);

    function onNumberListSuccess(resp) {
        const updatedList = resp.map((val, idx) => {
            val['key'] = idx + 1;
            // val['createdAt'] = new Date(val['createdAt']).toGMTString();
            return val;
        });
        setNumbersList(updatedList);
        setOriginalNumbersList(updatedList);
    }

      useEffect(() => {
        if(searchValue){
          setNumbersList(
             originalNumbersList.filter((number) => number.actual_number.toString().includes(searchValue.trim()))
          );
        }
        else {
            setNumbersList(originalNumbersList);
        }
      }, [searchValue]);

    function handleDeleteNumber(id) {
        checkAuth(setToastProps, setShowToast)
        setIsMultiDelete(false);
        setEnableDeleteModal(true);
        setDeleteNumberId(id);
    }

    const handleSelectAll = () => {
        if (selectedNumbers.length === numbersList.length) {
            setSelectedNumber([]);
        } else {
            const allNumberIds = numbersList.map(number => number.id);
            setSelectedNumber(allNumberIds);
        }
      };

      useEffect( () => {
        if (confirmDelete) {
            if (isMultiDelete) {
                postApiCall(API_NUMBER_DELETE, { numberIds: selectedNumbers })
                    .then(onDeleteSuccess)
                    .catch(onDeleteFail);
            } else {
                postApiCall(API_NUMBER_DELETE, { numberIds: [deleteNumberId] })
                    .then(onDeleteSuccess)
                    .catch(onDeleteFail);
            }
        }
        }, [confirmDelete]);
    

    function onDeleteSuccess(resp) {
        // setToastProps({ type: 'success', message: 'Number deleted successfully' });
            toast.success(resp.message || "Number deleted successfully");
        let updatedList;
        if (isMultiDelete) {
            updatedList = numbersList.filter(val => !selectedNumbers.includes(val.id)).map((val, key) => {
                val['key'] = key + 1;
                return val;
            });
            setSelectedNumber([]);
        } else {
            updatedList = numbersList.filter(val => val.id !== deleteNumberId).map((val, key) => {
                val['key'] = key + 1;
                return val;
            });
        }
        setNumbersList(updatedList);
        setEnableDeleteModal(false);
        setDeleteNumberId(undefined);
        setConfirmDelete(false); 
        setLoading(true);
        getApiCall(API_NUMBERS_LIST)
            .then(onNumberListSuccess)
            .catch(onError)
            .finally(() => setLoading(false));
    }

    function onDeleteFail(err) {
        if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
            errorCheck(err, navigate, setToastProps, setShowToast)
         } else {
        // setToastProps({ type: 'danger', message: `Unable to delete Number: ${err}` });
            toast.error(`Unable to delete Number: ${err}`);
         }
         setConfirmDelete(false);
    }

    const RenderActionComponent = ({id,number_type,routingType}) => {
        const numberEditRoute = ROUTES.NUMBERS.EDIT.replace(':id', id);
        const editDestinationRoute = ROUTES.IVR.UPDATE_INBOUND_CALLS.replace(':cid', id);
        return (
            <div className="flex align-items-center list-user-action">
                {(isSuperAdmin) && (
                    <EditIcon linkTo={`/${numberEditRoute}`} />
                )}
                {' '}
                {!(selectedNumbers.length > 0) && (isSuperAdmin) && (
                  <DeleteIcon handleCallback={() => handleDeleteNumber(id)} />
                )}
                {' '}
                {(number_type === 'VMN' || number_type === 'TOLL FREE') && (
                <Button className="btn btn-sm btn-icon btn-primary" title='Allocate' onClick={() => handleAllocateClick(id)}>
                    Allocate
                </Button>
                )}
                {((routingType === 'IVR' || routingType ==='AGENT' || routingType ==='QUEUE') && isCallcenterAdmin ) && (
                <Button className="btn btn-sm btn-icon btn-primary" title='Edit Destination' onClick={() =>  navigate(`/${editDestinationRoute}`)}>
                    Edit Destination
                </Button>
                )}


                
                
            </div>
        );

    }


    const handleBulkAssignClick = (type) => {
        setShowBulkAssignModal(true);

    };
    
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setCsvFile(file);
    };
    

    async function handleBulkAssign() {

        const formData = new FormData();
         formData.append('pool', 'pool');
         formData.append('phone_numbers', csvFile);
         formData.append("type", numberType); 
  
         postApiMediaCall(API_BULK_ASSIGN_DID, formData)
             .then(resp => {
                // setToastProps({ type: 'success', message: 'Bulk DID assigned successfully' });
                        toast.success("Bulk DID assigned successfully");
                            setShowBulkAssignModal(false);
                            getApiCall(API_NUMBERS_LIST)
                           .then(onNumberListSuccess)
                           .catch(onError);
                            
                 
             })
             .catch(err => {
                // setToastProps({ type: 'danger', message: `Failed to assign bulk DID: ${err}` });
                        toast.error(`Failed to assign bulk DID: ${err}`);
                            console.log("error",err);
             })
 
            }
    

    const handleAllocate = () => {
        const payload = {
            DID: selectedDID.label,
            DID_id: selectedDID.value,
            expiryDate: expiryDate,
            numberType:selectedNumberType,
            status: selectedStatus.toString(),
             id: allocateNumberId,
           
           };

        postApiCall(API_INDIVIDUAL_ASSIGN_DID,payload)
            .then(() => {
                // setToastProps({ type: 'success', message: 'Number allocated successfully' });
           toast.success("Number allocated successfully");
                setShowAllocateModal(false);
                setSelectedDID(null);
                setExpiryDate();
                getApiCall(API_NUMBERS_LIST)
                .then(onNumberListSuccess)
                .catch(onError);
              
            })
            .catch(err => {
                // setToastProps({ type: 'danger', message: `Allocation failed: ${err}` });
                        toast.error(`Allocation failed: ${err}`);
            });
    };

    const handleBulkUpdate =() =>{
        if (!updateNumberType) {
            toast.error("Number Type is required");
            return;
        }
        const formData = new FormData();
         formData.append('phone_numbers', csvFile);
         formData.append("numberType", updateNumberType);

         postApiMediaCall(API_NUMBER_EDIT_BULK, formData)
         .then(resp => {
            // setToastProps({ type: 'success', message: 'Bulk Update Successfull.' });
                    toast.success("Bulk Update Successfull.");
                        setShowBulkAssignModal(false);
                        getApiCall(API_NUMBERS_LIST)
                        .then(onNumberListSuccess)
                        .catch(onError);
             
         })
         .catch(err => {
            // setToastProps({ type: 'danger', message: `Failed to assign bulk update: ${err}` });
            toast.error(`Failed to assign bulk update: ${err}`);
                        console.log("error",err);
         })
    }
            
    const dropdownItemTemplate = (option) => {
        return <span>{option}</span>;
    }

    const numberTypeFilterTemplate = options => {
        return <Dropdown value={options.value} options={numberTypeLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
     }

     const categoryFilterTemplate = options => {
        return <Dropdown value={options.value} options={categoryLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select Category" className="p-column-filter" showClear />;
     }
     const currencyFilterTemplate = options => {
        return <Dropdown value={options.value} options={currencyLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select Currency" className="p-column-filter" showClear />;
     }
    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={NUBMERS_STATUS_LABEL} onChange={(e) => options.filterCallback(e.value)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
    }

    function onError(err) {
        if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
            errorCheck(err, navigate, setToastProps, setShowToast)
         } else {
           console.log(err)
         }
     }
    
    const handleCreateButtonClick = () => {
        navigate(`/${ROUTES.NUMBERS.CREATE}`)
     } 

     const handleNumberTypeFilter = (type) => {
        setNumberType(type);
        setShowAssignDidButton(type === 'VMN' || type === 'TOLL FREE');
    
        setFilters((prevFilters) => {
            if (type === 'All') {
                const { number_type, ...remainingFilters } = prevFilters;
                return remainingFilters;
            }
            return {
                ...prevFilters,
                number_type: { value: type, matchMode: FilterMatchMode.EQUALS },
            };
        });
    
        if (type === '') {
            setBulkUpdateButton(false);
        } else {
            setBulkUpdateButton(true);
        }
    };
    

    const resetAllocateModalState = () => {
        setSelectedDID(null);
        setSelectedStatus(null);
        setExpiryDate(null);
        setExpiryDateError("");
        setUpdateNumberType(null);
        
    };



    const handleExpiryDateChange = (e) => {
        const date = e.target.value;
        const today = new Date();
        const selectedDate = new Date(date);

        if (selectedDate <= today) {
            setExpiryDateError("Expiry date must be in the future");
        } else {
            setExpiryDateError("");
        }

        setExpiryDate(date);
    };

  
     const rowClassName = (data) => {
        return {
            'highlighted-row': selectedNumbers.includes(data.id)
          };
    }

    const dropdownOptionStatus = allocateStatus.map(item =>({label:item.status,value:item.status_code}))

    
    const handleBulkUpdateButtonClick = (type) => {
        setBulkUpdateModal(true);
    };


    const getColumnsAndFilename = (numberType) => {
        let columns;
        let filename;
        let sample_data;
    
        if (numberType === 'DID') {
            columns = BULK_UPDATE_DID;
            filename = `${numberType}-Update.csv`;
            sample_data = SAMPLE_DATA_DID_UPDATE;
        } else if (numberType === 'VMN') {
            columns = BULK_UPDATE_OTHERS;
            filename = `${numberType}-Update.csv`;
            sample_data = SAMPLE_DATA_OTHERS_UPDATE;
        } else {
            columns = BULK_UPDATE_OTHERS;
            filename = `${numberType}-Update.csv`;
            sample_data = SAMPLE_DATA_OTHERS_UPDATE;
        }
    
        return { columns, filename, sample_data };
    };

    const getColumnsAndFilenameForAssignDID = (numberType) => {
        let columns;
        let filename;
    
        if (numberType === 'VMN') {
            columns = ASSIGN_DID_VMN;
            filename = `${numberType}-AssignDID.csv`;
        } else {
            columns = ASSIGN_DID_TOLLFREE;
            filename = `${numberType}-AssignDID.csv`;
        }
    
        return { columns, filename };
    };


    useEffect(() => {
        if (!originalNumbersList.length) return;

        const typeMap = ["DID", "VMN", "TOLL FREE"];
        const selectedType = typeMap[activeIndex];

        if (!selectedType) {
            setNumbersList(originalNumbersList);
            return;
        }

        const filtered = originalNumbersList.filter(
            (item) => item.number_type === selectedType
        );

        setNumbersList(filtered);
    }, [activeIndex, originalNumbersList]);

    if (loading) {
        return <Loader />
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title">Numbers List</h4>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                {userRole === USER_ROLES.CALL_CENTRE_ADMIN && (
                                    <>
                                        {/* Icons before refresh */}
                                        <img src={agentImg} alt="Agent" title="Agent" style={{ width: "30px", height: "30px" }} /> - Agent
                                        <img src={ivrImg} alt="IVR" title="IVR" style={{ width: "30px", height: "30px" }} /> - IVR
                                        <img src={callgroupImg} alt="Call Group" title="Call Group" style={{ width: "30px", height: "30px" }} /> - CallGroup         
                                    </>
                                )}
                                

                                {/* Buttons */}
                                <button className="btn btn-primary me-2" onClick={() => {
                                    setActiveIndex(0);
                                    setNumberType("DID");
                                    setShowAssignDidButton(false);
                                    // setBulkUpdateButton(false);
                                    getApiCall(API_NUMBERS_LIST)
                                        .then(onNumberListSuccess)
                                        .catch(onError);
                                }}>Refresh</button>

                                {(isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.add) && (
                                <button className="btn btn-primary" onClick={handleCreateButtonClick}>
                                    <FiPlus className="me-1" />
                                    Create Number
                                </button>
                                )}

                                {userRole === USER_ROLES.CALL_CENTRE_ADMIN && (
                                <button 
                                    className="btn btn-primary m-2" 
                                    onClick={() => navigate(`/${ROUTES.IVR.INBOUND_CALLS.replace(":cid", contentId)}`)}>
                                    Inbound Calling
                                </button>
                                )}
                            </div>
                            </Card.Header>

                            <Card.Body className="px-0">
                                <div className="custom-tab-container">
                                    <Row className="d-flex align-items-center">
                                    
                                        <Col className="d-flex justify-content-end">
                                            {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.delete)) && (
                                                <Button
                                                    label="Delete Selected"
                                                    onClick={handleMultiDelete}
                                                    className="p-button-danger"
                                                    style={{ fontSize: "14px", padding: "0px 8px", marginLeft: "10px" }}
                                                    disabled={selectedNumbers.length === 0}
                                                />
                                            )}
                                            {numbersList.length > 0 && (isSuperAdmin || loggedUser.role === USER_ROLES.SUB_SUPERADMIN) &&
                                             <Button 
                                             label="Export Data"
                                             icon="pi pi-file-export"
                                             onClick={handleExport} 
                                             className="p-button-active" 
                                             style={{ fontSize: "14px", padding: "0px 8px", marginLeft: "10px" }}
                                             disabled={buttonDisable} 
                                             >
                                             &nbsp;
                                             {buttonDisable && (
                                                 <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                             )}
                                             </Button>
                                            }
                                           

                                            <Form.Group style={{height: "45px"}}>
                                                <Form.Control
                                                    style={{marginLeft: "10px",marginRight: "10px", margintop: "5px" ,border: "1px solid #ced4da", fontSize: "14px", height: "44px", width: "200px"}}
                                                    placeholder = 'Search by Number...'
                                                    type="number"
                                                    maxLength={100}
                                                    value={searchValue}
                                                    onChange={(e) => setSearchValue(e.target.value)}
                                                    required
                                                />
                                            </Form.Group>

                                            {(showAssignDidButton) && (
                                                <button className="btn btn-success btn-sm button-spacing" onClick={() => handleBulkAssignClick(numberType)}>Assign User</button>
                                            )}
                                            {(bulkUpdateButton) && (
                                                <button className="btn btn-success btn-sm button-spacing" onClick={() => handleBulkUpdateButtonClick(numberType)}>Bulk Update</button>
                                            )}

                                        </Col>
                                       

                                    </Row>
                                    <TabView 
                                        activeIndex={activeIndex} 
                                        onTabChange={(e) => {
                                            setActiveIndex(e.index)
                                            setNumberType(["DID", "VMN", "TOLL FREE"][e.index])
                                            setShowAssignDidButton(
                                                ["VMN", "TOLL FREE"].includes(["DID", "VMN", "TOLL FREE"][e.index])
                                            );
                                            setBulkUpdateButton(true);
                                        }}>
                                        {["DID", "VMN", "TOLL FREE"].map((tab, index) => (
                                        <TabPanel
                                            key={index}
                                            header={
                                            <span
                                            style={{
                                                display: "inline-block",
                                                borderRadius: "5px",
                                                fontWeight: activeIndex === index ? "bold" : "normal",
                                                border: 'none'
                                              }}
                                            >
                                                {tab}
                                            </span>
                                            }
                                        >
                                            <div className="scroll-container">
                                                <DataTable value={numbersList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                                                    <Column 
                                                        header={<Checkbox 
                                                        checked={selectedNumbers.length === numbersList.length && numbersList.length > 0} 
                                                        onChange={handleSelectAll} 
                                                        />} 
                                                        headerStyle={{ width: '3rem' }} 
                                                        body={(rowData) =>
                                                            (
                                                            
                                                            <Checkbox 
                                                            checked={selectedNumbers.includes(rowData.id)} 
                                                            onChange={() => handleCheckboxToggle(rowData.id)} 
                                                            />
                                                            
                                                            )} 
                                                    />
                                                    <Column field="actual_number" filterField="actual_number" header={numberType} filter filterPlaceholder="Search by Number" body={(rowData) => rowData.actual_number || '-'}></Column>
                                                    <Column field="country_code" filterField="country_code" header="Country Code" filter filterPlaceholder="Search by Country Code" body={(rowData) => rowData.country_code || '-'}></Column>
                                                    <Column field="state_code" filterField="state_code" header="State Code" filter filterPlaceholder="Search by State Code" body={(rowData) => rowData.state_code || '-'}></Column>
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="cost" filterField="cost" header="Cost" filter filterPlaceholder="Search by Cost" body={(rowData) => rowData.cost || '-'}></Column>
                                                    )}
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="operator" filterField="operator" header="Operator" filter filterPlaceholder="Search by Operator" body={(rowData) => rowData.operator || '-'}></Column>
                                                    )}
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="category" filterField="category" header="Category" filter filterPlaceholder="Search by Category" filterElement={categoryFilterTemplate} body={(rowData) => rowData.category || '-'}></Column>
                                                    )}
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="currency" filterField="currency" header="Currency" filter filterPlaceholder="Search by Currency"  filterElement={currencyFilterTemplate} body={(rowData) => rowData.currency || '-'}></Column>
                                                    )}
                                                
                                                    <Column field="number_type" filterField="number_type" header="Number Type" filter filterPlaceholder="Search by Number Type" filterElement={numberTypeFilterTemplate} body={(rowData) => rowData.number_type || '-'}></Column>
                                                    <Column field="trunkId.name" header="Trunk" body={(rowData) => rowData?.trunkId?.name || '-'}></Column>
                                                   <Column
                                                        field="status"
                                                        header="Status"
                                                        filterElement={statusFilterTemplate}
                                                        filter
                                                        body={(rowData) => {
                                                            if (isSuperAdmin) {
                                                            return rowData.allocated_to === null ? rowData.status : 'Allocated';
                                                            }

                                                            if (isReseller) {
                                                                if (
                                                                    rowData.allocated_to &&
                                                                    rowData.allocated_to.id === loggedUserId &&
                                                                    rowData.allocated_to.type === loggedUserType
                                                                ) {
                                                                    return rowData.status;
                                                                } else {
                                                                    return 'Allocated';
                                                                }
                                                            }
                                                            if (isCompanyUser) {
                                                                if (
                                                                    rowData.allocated_to &&
                                                                    rowData.allocated_to.id === loggedUser.company_id &&
                                                                    rowData.allocated_to.type === loggedUserType
                                                                ) {
                                                                    return rowData.status;
                                                                } else {
                                                                    return 'Allocated';
                                                                }
                                                            }
                                                            if (isCallcenterAdmin) {
                                                                if (
                                                                    rowData.allocated_to &&
                                                                    rowData.allocated_to.id === loggedUser.callcenter_id &&
                                                                    rowData.allocated_to.type === loggedUserType
                                                                ) {
                                                                    return rowData.status;
                                                                } else {
                                                                    return 'Allocated';
                                                                }
                                                            }

                                                            // Default fallback
                                                            return rowData.status || '-';
                                                        }}
                                                    />
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="routing_id" filterField="routing_id" header="Routing Id" filter filterPlaceholder="Search by Routing Id" body={(rowData) => rowData.routing_id || '-'}></Column>
                                                    )}
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="routing_type" filterField="routing_type" header="Routing Type" filter filterPlaceholder="Search by Routing Type"  
                                                        body={(rowData) => {
                                                            if (rowData.routing_type) {
                                                            if (rowData.routing_type == "AGENT") {
                                                                return <img src={agentImg} alt='Agent' style={{ width: "30px", height: "30px" }} title="Agent"/>
                                                            }
                                                            else if (rowData.routing_type == "IVR") {
                                                                return <img src={ivrImg} alt='IVR' style={{ width: "30px", height: "30px" }} title='IVR'/>
                                                            }
                                                            else if (rowData.routing_type == "QUEUE") {
                                                                return <img src={callgroupImg} alt='Call Group' style={{ width: "30px", height: "30px" }} title='Call Group'/>
                                                            }
                                                            return rowData.routing_type;
                                                            } else {
                                                            return '-';
                                                            }
                                                        }}></Column>
                                                    )}
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="routing_destination" filterField="routing_destination" header="Routing Destination" filter filterPlaceholder="Search by Routing"  body={(rowData) => rowData.routing_destination || '-'}></Column>
                                                    )}
                                                    {}
                                                    <Column
                                                        field="voice_plan_id.plan_name"
                                                        header="Plan Name"
                                                        body={(rowData) => {
                                                            const planName = rowData?.voice_plan_id?.plan_name;
                                                            return planName ? (
                                                            <button
                                                                onClick={() => {
                                                                setSelectedPlanDetails(rowData.voice_plan_id.plans || []);
                                                                setSelectedPlanName(planName);
                                                                setShowPlanModal(true);
                                                                }}
                                                                style={{
                                                                backgroundColor: '#f0f0f0',  // light grey
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px',
                                                                padding: '4px 8px',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                }}
                                                            >
                                                                {planName}
                                                            </button>
                                                            ) : null;
                                                        }}
                                                    />

                                                    <Column
                                                        field="allocated_to.name"
                                                        header="Allocated To"
                                                    ></Column>
                                                    <Column
                                                        field="allocated_to.type"
                                                        header="Allocated Type"
                                                    ></Column>
                                                
                                                    <Column field="createdAt" header="Created Date"
                                                     body={(rowData) =>
                                                        new Date(rowData.createdAt).toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                        })
                                                    }
                                                    ></Column>
                                                    {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.edit || moduleOperations?.[MODULE_ACL.NUMBERS]?.delete)) && (
                                                    //   <Column header="Action" body={actionBodyTemplate} />
                                                    <Column  header="Action" body={(rowData)=><RenderActionComponent id={rowData.id} number_type={rowData.number_type} routingType={rowData.routing_type} />}></Column>
                                                    )}
                                                </DataTable>
                                            </div>
                                        </TabPanel>
                                        ))}
                                    </TabView>

                                   
                                    {(!["DID", "VMN", "TOLL FREE"].includes(["DID", "VMN", "TOLL FREE"][activeIndex])) && (
                                        <div className="scroll-container">
                                            <DataTable value={numbersList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                                                <Column 
                                                    header={<Checkbox 
                                                    checked={selectedNumbers.length === numbersList.length && numbersList.length > 0} 
                                                    onChange={handleSelectAll} 
                                                    />} 
                                                    headerStyle={{ width: '3rem' }} 
                                                    body={(rowData) => (
                                                        <Checkbox 
                                                        checked={selectedNumbers.includes(rowData.id)} 
                                                        onChange={() => handleCheckboxToggle(rowData.id)} 
                                                        />
                                                        )} 
                                                />
                                                <Column field="actual_number" filterField="actual_number" header={numberType} filter filterPlaceholder="Search by Number" body={(rowData) => rowData.actual_number || '-'}></Column>
                                                <Column field="country_code" filterField="country_code" header="Country Code" filter filterPlaceholder="Search by Country Code" body={(rowData) => rowData.country_code || '-'}></Column>
                                                <Column field="state_code" filterField="state_code" header="State Code" filter filterPlaceholder="Search by State Code" body={(rowData) => rowData.state_code || '-'}></Column>
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="cost" filterField="cost" header="Cost" filter filterPlaceholder="Search by Cost" body={(rowData) => rowData.cost || '-'}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="operator" filterField="operator" header="Operator" filter filterPlaceholder="Search by Operator" body={(rowData) => rowData.operator || '-'}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="category" filterField="category" header="Category" filter filterPlaceholder="Search by Category" filterElement={categoryFilterTemplate} body={(rowData) => rowData.category || '-'}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="currency" filterField="currency" header="Currency" filter filterPlaceholder="Search by Currency"  filterElement={currencyFilterTemplate} body={(rowData) => rowData.currency || '-'}></Column>
                                                )}
                                            
                                                <Column field="number_type" filterField="number_type" header="Number Type" filter filterPlaceholder="Search by Number Type" filterElement={numberTypeFilterTemplate} body={(rowData) => rowData.number_type || '-'}></Column>
                                                <Column field="status" header="Status" filterElement={statusFilterTemplate} filter body={(rowData) => rowData.status || '-'}></Column>
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="routing_id" filterField="routing_id" header="Routing Id" filter filterPlaceholder="Search by Routing Id" body={(rowData) => rowData.routing_id || '-'}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="routing_type" filterField="routing_type" header="Routing Type" filter filterPlaceholder="Search by Routing Type"  
                                                    body={(rowData) => {
                                                        if (rowData.routing_type) {
                                                        if (rowData.routing_type == "AGENT") {
                                                            return <img src={agentImg} alt='Agent' style={{ width: "23px", height: "23px" }} title="Agent"/>
                                                        }
                                                        else if (rowData.routing_type == "IVR") {
                                                            return <img src={ivrImg} alt='IVR' style={{ width: "23px", height: "23px" }} title='IVR'/>
                                                        }
                                                        else if (rowData.routing_type == "CALL GROUP") {
                                                            return <img src={callgroupImg} alt='Call Group' style={{ width: "23px", height: "23px" }} title='Call Group'/>
                                                        }
                                                        return rowData.routing_type;
                                                        } else {
                                                        return '-';
                                                        }
                                                    }}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="routing_destination" filterField="routing_destination" header="Routing Destination" filter filterPlaceholder="Search by Routing"  body={(rowData) => rowData.routing_destination || '-'}></Column>
                                                )}
                                            
                                                <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                                {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.edit || moduleOperations?.[MODULE_ACL.NUMBERS]?.delete)) && (
                                                //   <Column header="Action" body={actionBodyTemplate} />
                                                <Column  header="Action" body={(rowData)=><RenderActionComponent id={rowData.id} number_type={rowData.number_type} routingType = {rowData.routing_type} />}></Column>
                                                )}
                                            </DataTable>
                                        </div>
                                    )}
                                        
                                   
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            {/* Delete Modal */}
            <RenderDeleteModal 
                show={enableDeleteModal} 
                setShow={setEnableDeleteModal} 
                setConfirmDelete={setConfirmDelete} 
                isMultiDelete={isMultiDelete} 
                clearSelectedData={() => setSelectedNumber([])}
            />

            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

            {/* Assign Individual DID Modal */}
            {showAllocateModal && (
                <Modal show={showAllocateModal} onHide={() => {setShowAllocateModal(false); resetAllocateModalState();}}>
                    <Modal.Header closeButton>
                        <Modal.Title>Allocate DID</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formDid">
                                <Form.Label>Select DID</Form.Label>
                                <Dropdown
                                    value={selectedDID?.value}
                                    options={didOptions}
                                    onChange={(e) => {
                                        const selectedOption = didOptions.find(option => option.value === e.value);
                                        setSelectedDID(selectedOption)
                                    }}
                                    placeholder="Select a DID"
                                    className="form-control p-0" 
                                    style={{height:"45px"}}
                                    appendTo="self"
                                    
                                />
                            </Form.Group>
                            <Form.Group controlId="formStatus">
                                <Form.Label>Select Status</Form.Label>
                                <Dropdown
                                    value={selectedStatus}
                                    options={dropdownOptionStatus}
                                    onChange={(e) => setSelectedStatus(e.value)}
                                    placeholder="Select Status"
                                    className="form-control p-0"style={{ height: "45px" }}
                                    appendTo="self"
                                />
                            </Form.Group>

                            {selectedStatus && ["Reserved", "Blocked"].includes(dropdownOptionStatus.find(option => option.value === selectedStatus)?.label) && (
                               <div className="expiry-date-container">
                                  <Form.Group as={Col} controlId="expiryDate">
                                     <Form.Label>Expiry Date</Form.Label>
                                     <Form.Control
                                        type="date"
                                        value={expiryDate}
                                        onChange={handleExpiryDateChange}
                                        isInvalid={!!expiryDateError}
                                      />
                                   <Form.Control.Feedback type="invalid">
                                        {expiryDateError}
                                   </Form.Control.Feedback>
                                 </Form.Group>
                                </div>
                            )}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="custom-modal-footer">
                        <Button className="p-button-secondary" onClick={() => {setShowAllocateModal(false); resetAllocateModalState();}}>
                            Close
                        </Button>
                        <Button className="p-button-primary" onClick={handleAllocate}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}


                {/* Assign BULK DID Modal */}
                <Modal show={showBulkAssignModal} onHide={() => setShowBulkAssignModal(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title  style={{fontSize: '16px'}}>Bulk Assign DID for {numberType}</Modal.Title>
                  </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Button variant="primary" 
                            onClick={(event) => {
                                const { columns, filename } = getColumnsAndFilenameForAssignDID(numberType);
                                downloadTemplate(event, columns, filename);
                            }}
                            style={{ marginBottom: '15px' }}
                        >
                           Download Template
                        </Button>
                        <Form.Group controlId="formFile">
                            {/* <Form.Label>Upload CSV File</Form.Label> */}
                            <Form.Control type="file" onChange={(e) =>handleFileUpload(e)} accept=".csv" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="custom-modal-footer">
                    <Button variant="p-button-secondary button-sm" onClick={() => {setShowBulkAssignModal(false); setShowAssignDidButton(false)}}>
                      Close
                    </Button>
                    <Button variant="p-button-primary button-sm" onClick={handleBulkAssign}>
                        Upload
                    </Button>
                </Modal.Footer>
                </Modal>

                {/* Bulk Update Model  */}
                <Modal show={bulkUpdateModal} onHide={()=> setBulkUpdateModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Bulk Update</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form>
                            
                                <div className='row'>
                                    <Form.Group className="col-md-12 form-group">
                                        <Form.Label>Select Number Type</Form.Label>
                                        <Form.Select
                                            id="numberType"
                                            value={updateNumberType}
                                            className="p-2"
                                            onChange={(e) =>setUpdateNumberType(e.target.value)}
                                            required
                                        >
                                            <option value={""}>Select Number Type</option>
                                            {NUMBERS_TYPES.map(function(val,idx){
                                            return(
                                                <option key ={idx} value={val.value}>
                                                {val.label}
                                                </option>
                                            )
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div>
                                    {updateNumberType && (
                                        <>
                                            <Button variant="primary" 
                                                onClick={(event) => {
                                                    const { columns, filename, sample_data } = getColumnsAndFilename(updateNumberType);
                                                    downloadTemplate(event, columns, filename, null, sample_data);
                                                }}
                                                style={{
                                                    marginBottom: '15px',
                                                    backgroundColor: '#3a57e8',
                                                    borderColor: '#3a57e8',
                                                    fontSize: '16px',
                                                    borderRadius: '5px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                                                    }}
                                                    >
                                                    Download Template
                                            </Button>
                                            {updateNumberType && (
                                                    <div
                                                      style={{
                                                        background: "#FFF8C6",
                                                        color: "#6B4E16",
                                                        padding: "14px 16px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #FFE08A",
                                                        fontSize: "14px",
                                                        lineHeight: "1.6",
                                                      }}
                                                    >
                                                      <div style={{ fontWeight: 600, marginBottom: "6px" }}>
                                                        ⚠️ Important Information
                                                      </div>
                                            
                                                      <ul style={{ margin: 0, paddingLeft: "18px" }}>
  <li>
    Please use the following values to set the respective status in the Status column of the downloaded template:
    <ul>
      <li><strong>1</strong> – Available</li>
      <li><strong>2</strong> – Reserved</li>
      <li><strong>3</strong> – Blocked</li>
      <li><strong>4</strong> – Archived</li>
      <li><strong>6</strong> – Demo</li>
      <li><strong>7</strong> – Live</li>
      <li><strong>8</strong> – Delete</li>
      <li><strong>9</strong> – Pending</li>
      <li><strong>10</strong> – Reject</li>
    </ul>
  </li>
</ul>

                                                    </div>
                                                  )}
                                                  <hr />
                                        </>
                                        )}
                            </div>
                            {updateNumberType && (
                                <Form.Group controlId="formFile">
                                    <Form.Label>Upload </Form.Label>
                                    <Form.Control type="file" onChange={(e) =>handleFileUpload(e)} accept=".csv, .xls, application/vnd.ms-excel" />
                                </Form.Group>
                            )}
                            </Form>
                        </Modal.Body>

                        <Modal.Footer className="custom-modal-footer">
                            <Button variant="p-button-secondary" onClick={() => {setBulkUpdateModal(false); resetAllocateModalState(); setShowAssignDidButton(false);}}>
                            Close
                            </Button>
                            <Button variant="p-button-primary" onClick={() => {handleBulkUpdate(); setBulkUpdateModal(false); resetAllocateModalState(); setShowAssignDidButton(false);}}>
                                Upload
                            </Button>
                        </Modal.Footer>
                    
                </Modal>

                <Modal
                    show={showPlanModal}
                    onHide={() => setShowPlanModal(false)}
                    centered
                    >
                    <Modal.Header closeButton>
                        <Modal.Title>Plan Details - {selectedPlanName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedPlanDetails.length > 0 ? (
                        <div>
                            {selectedPlanDetails.map((plan, index) => (
                            <div key={index} style={{ marginBottom: '10px' }}>
                                <strong>{plan.plan_type}</strong><br />
                                Pulse Duration: {plan.pulse_duration}<br />
                                Pulse Price: {plan.pulse_price}
                            </div>
                            ))}
                        </div>
                        ) : (
                        <div>No plan details available.</div>
                        )}
                    </Modal.Body>
                </Modal>

        </>
    )

}